var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnowledgeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_993_61919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8799 20.4527C17.3976 20.4527 17.8174 20.0329 17.8174 19.5152C17.8174 18.9974 17.3976 18.5777 16.8799 18.5777C16.3621 18.5777 15.9424 18.9974 15.9424 19.5152C15.9424 20.0329 16.3621 20.4527 16.8799 20.4527Z",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4251 9.67147C19.7545 10.129 19.9645 10.6759 20.0066 11.2622C20.0893 12.4165 19.5344 13.5187 18.5586 14.1388C18.094 14.434 17.8167 14.9175 17.8167 15.4322V15.9875C17.8167 16.5052 17.3969 16.925 16.8792 16.925C16.3614 16.925 15.9417 16.5052 15.9417 15.9875V15.4322C15.9417 14.2725 16.5441 13.1974 17.5529 12.5562C17.9462 12.3063 18.1698 11.8618 18.1364 11.3961C18.0932 10.794 17.609 10.2955 17.01 10.2366C16.3307 10.1702 15.7244 10.643 15.6308 11.3138C15.5591 11.8265 15.0852 12.1841 14.5727 12.1127C14.0599 12.0411 13.7022 11.5674 13.7738 11.0546C14.0068 9.38403 15.5089 8.20397 17.1934 8.37059C17.3497 8.38597 17.5029 8.41328 17.652 8.45159",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43319 5.44272C7.54819 6.92366 7.04087 8.65297 7.04594 10.4942C7.05387 13.3504 8.27837 15.9202 10.2285 17.7132C11.6714 19.04 12.5147 20.8945 12.5147 22.8546V23.7476",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9029 17.3725C25.6529 15.5958 26.7329 13.1573 26.7329 10.4663C26.7329 5.00441 22.2844 0.581471 16.8129 0.622908C14.0408 0.643908 11.5352 1.82435 9.75586 3.69903",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2646 23.7476V22.8547C21.2646 21.4703 21.6736 20.1253 22.4315 18.996",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8887 6.01553V4.76553",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6396 6.76366L20.6373 5.03566",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6523 8.77834L22.5898 8.23709",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3906 11.5288H24.386",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1373 6.76366L13.1396 5.03566",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0996 8.76427L11.1621 8.22302",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.386 11.5288H9.39062",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1396 26.9351H12.1845C11.8491 26.9351 11.5771 26.6632 11.5771 26.3277V24.4175C11.5771 24.0821 11.8491 23.8102 12.1845 23.8102H21.5947C21.9301 23.8102 22.2021 24.0821 22.2021 24.4175V26.3277C22.2021 26.6632 21.9301 26.9351 21.5947 26.9351H17.3271",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2646 26.9976V28.1851C21.2646 28.5303 20.9848 28.8101 20.6396 28.8101H13.1396C12.7945 28.8101 12.5146 28.5303 12.5146 28.1851V26.9976",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3271 28.8726V31.0296C20.3271 31.3916 20.0336 31.6851 19.6716 31.6851H14.1076C13.7456 31.6851 13.4521 31.3916 13.4521 31.0296V28.8726",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8896 31.6851V30.6851",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6084 31.6851V30.6851",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1709 31.6851V30.6851",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_993_61919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.889648 0.153839)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeIcon);
export default __webpack_public_path__ + "static/media/knowledgeIcon.49715857d9848bcd98af878673eaec2f.svg";
export { ForwardRef as ReactComponent };